// import axios from 'axios';
//
// export const api = axios.create({
//     baseURL: 'http://localhost:8080/api',
//     // baseURL: 'http://186.246.29.67:8080/api',
//
//     headers: {
//         'Content-Type': 'application/json',
//     },
//     withCredentials: false,
// });
//
// api.interceptors.request.use(
//     config => {
//         const token = localStorage.getItem('adminToken');
//         if (token) {
//             config.headers['Authorization'] = `Bearer ${token}`;
//         }
//         return config;
//     },
//     error => Promise.reject(error)
// );

import axios from 'axios';

export const api = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false,
});

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);